import {Link, useLocation} from "react-router-dom";

const Tech_ul = () => {
    const location = useLocation();

    const isActive = (path) => location.pathname === path ? 'active' : '';
    return (
        <>
            <ul className="single-sidebar__service-list">
                <li>
                    <Link to="/ai-models" className={isActive("/ai-models")}>
                        AI Insights Pro <span className="icon-long-right-arrow"/>
                    </Link>
                </li>
                <li>
                    <Link to="/tech-armor-security" className={isActive("/tech-armor-security")}>
                        Tech Armor Security <span className="icon-long-right-arrow"/>
                    </Link>
                </li>
                <li>
                    <Link to="/block-chain-forge" className={isActive("/block-chain-forge")}>
                        Blockchain Forge <span className="icon-long-right-arrow"/>
                    </Link>
                </li>
                <li>
                    <Link to="/digital-iq-consulting" className={isActive("/digital-iq-consulting")}>
                        DigitalIQ Consulting <span className="icon-long-right-arrow"/>
                    </Link>
                </li>
                <li>
                    <Link to="/rapid-app-innovative" className={isActive("/rapid-app-innovative")}>
                        RapidApp Innovate <span className="icon-long-right-arrow"/>
                    </Link>
                </li>
                <li>
                    <Link to="/robo-logic-labs" className={isActive("/robo-logic-labs")}>
                        RoboLogic Labs <span className="icon-long-right-arrow"/>
                    </Link>
                </li>
            </ul>
        </>
    )
}

export default Tech_ul